module.exports = __webpack_public_path__ + "media/CogFuture.72cee081.wav";